export default __webpack_public_path__ + "static/media/Cw.0faee2a5.png";